module.exports = __webpack_public_path__ + "img/happylandlogo.ae6749c3.png";